import Theme from '@adsk/alloy-react-theme';

export const containerStyle = {
  paddingBottom: '16px',
  display: 'flex',
  'flex-direction': 'row',
  'justify-content': 'space-between',
};

export const textNameStyle = {
  ...Theme.typography.bodyMedium,
};

export const textExpiredStyle = (daysLeft: number | null) => ({
  ...Theme.typography.bodyMedium,
  color:
    daysLeft !== null && daysLeft < 3
      ? Theme.colors.red500
      : Theme.colors.charcoal900,
});

export const buttonStyle = {
  ...Theme.typography.labelSmall,
  height: '24px',
  minWidth: '134px',
  padding: '0 8px',
};
